/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from 'react';
import { Provider } from 'react-redux'
import store from './store'
import IesAuth from './common/IesAuth';
import env from './common/env'
import Routes from './routes';
import 'edw-widgets/dist/index.css'
import {getGTMScript} from './common/GoogleAnalytics'

import './App.scss'

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSessionExist: false
    }
  }

  componentDidMount() {
    this.iesAuth = new IesAuth(env);
    this.iesAuth.init(store);
    
    const scriptContent =  getGTMScript(env);
    const scriptElement = document.createElement('script');
    scriptElement.innerText = scriptContent;
    document.head.appendChild(scriptElement);
    
  }


  onIESInit = (...rest) => {
    // let [userID, accessToken] = rest
    // if (accessToken) {
    //   this.setState({ isSessionExist: true })
    // }
  }

  render() {
    return (
      <Provider store={store}>
        <Routes iesAuth={this.iesAuth} />
      </Provider>
    );
  }
}





